import React from 'react';

const Louisiana = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Louisiana Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>
          Disclosure of material facts required; form provided by the Louisiana
          Real Estate Commission.
        </li>
        <li>Property Disclosure Document: Mandatory for residential sales.</li>
        <li>Termite Inspection: Commonly required due to local conditions.</li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            Lead-Based Paint Disclosure{' '}
          </span>{' '}
          – Only for residences that were built before 1978. This information
          should be available at the County’s Revenue Office.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            Property Disclosure Document{' '}
          </span>{' '}
          – Sellers must provide potential buyers with a full disclosure
          statement revealing the material condition of the property.
        </li>
      </ol>
    </div>
  );
};

export default Louisiana;
